const RightArrow = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M0 7L14 7M7 0L14 7 7 14" transform="translate(1 1)" />
      </g>
    </svg>
  );
};

export { RightArrow };
